export const GermanTimezone = "Europe/Berlin";
export const UtcTimezone = "UTC";
